import { render } from "./AmountSeparatorsForm.vue?vue&type=template&id=1a0f4e7e&scoped=true&ts=true"
import script from "./AmountSeparatorsForm.vue?vue&type=script&lang=ts"
export * from "./AmountSeparatorsForm.vue?vue&type=script&lang=ts"

import "./AmountSeparatorsForm.vue?vue&type=style&index=0&id=1a0f4e7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0f4e7e"]])

export default __exports__